module.exports = __webpack_public_path__ + "static/media/navidad.5a9b5d0d.svg";